import type { IconSvgObject } from './types';

const Chemistry03Icon: IconSvgObject = [
  ["path", { d: "M3 9L11.5 9.00001M21 9L15.5 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 3V19C5 20.1046 5.89543 21 7 21H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10.5 4L16.5 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M11.5 4V9.70475C10.0183 10.4206 9 11.9072 9 13.625C9 16.0412 11.0147 18 13.5 18C15.9853 18 18 16.0412 18 13.625C18 11.9072 16.9817 10.4207 15.5 9.70475V4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Chemistry03Icon;
